import { fromJS, List as ImmutableList } from 'immutable';
import { FILTER_OPERATORS_USING_VALUE } from './constants';
import { getCustomFiltersFromTableReport, getFilterOperatorForCheckboxTable, getFilterValuesFromFilterForCheckboxTable, getIsUAReportWithBreakdownDimension } from './utils';
const getFilterFromReportByFilterNameForCheckboxTable = (report, selectedFilterName, dimensionMetaData) => {
  const selectedDimension = selectedFilterName === 'filters' ? 'breakdown' : selectedFilterName;
  const isUAReportWithBreakdownDimension = getIsUAReportWithBreakdownDimension(report, selectedDimension);
  const customFilters = getCustomFiltersFromTableReport(report);
  const filterOperator = getFilterOperatorForCheckboxTable(selectedFilterName, dimensionMetaData);
  const selectedFilterIndex = customFilters.findIndex(filter => !!filter && filter.get('property') === selectedFilterName && (filter.get('operator') === filterOperator || isUAReportWithBreakdownDimension));
  const isFilterNotInReport = selectedFilterIndex === -1;
  let selectedFilter;
  if (isFilterNotInReport) {
    selectedFilter = fromJS(Object.assign({
      property: selectedFilterName
    }, FILTER_OPERATORS_USING_VALUE.includes(filterOperator || '') ? {
      value: ''
    } : {
      values: []
    }, filterOperator ? {
      operator: filterOperator
    } : {}));
  } else {
    selectedFilter = customFilters.get(selectedFilterIndex);
  }
  return selectedFilter;
};
export const updateReportFilterForCheckboxTableConfig = (report, selectedFilterName, selectedFilterValueForUpdate, dimensionMetaData) => {
  const selectedFilter = getFilterFromReportByFilterNameForCheckboxTable(report, selectedFilterName, dimensionMetaData);
  const filterOperator = selectedFilter.get('operator');
  const currentFilterValues = getFilterValuesFromFilterForCheckboxTable(selectedFilter);
  const useValueStringInsteadOfValuesArrayInFilter = FILTER_OPERATORS_USING_VALUE.includes(filterOperator || '');
  let updatedFilter;
  if (useValueStringInsteadOfValuesArrayInFilter) {
    const filterValueIndex = currentFilterValues.findIndex(value => value === selectedFilterValueForUpdate);
    const isNewFilterValueInCurrentFilter = filterValueIndex === -1;
    if (isNewFilterValueInCurrentFilter) {
      currentFilterValues.push(selectedFilterValueForUpdate);
    } else {
      currentFilterValues.splice(filterValueIndex, 1);
    }
    const updatedFilterValue = currentFilterValues.join(' OR ');
    updatedFilter = selectedFilter.set('value', updatedFilterValue);
  } else {
    const updatedFilterValueIndex = currentFilterValues.findIndex(value => value === selectedFilterValueForUpdate);
    const isNewFilterValueInCurrentFilter = updatedFilterValueIndex === -1;
    updatedFilter = selectedFilter.update('values', values => isNewFilterValueInCurrentFilter ? values.push(selectedFilterValueForUpdate) : values.delete(updatedFilterValueIndex));
  }
  return updatedFilter;
};
export const overwriteFilterValuesInCheckboxTable = (report, selectedFilterName, filterValues, dimensionMetaData) => {
  const selectedFilter = getFilterFromReportByFilterNameForCheckboxTable(report, selectedFilterName, dimensionMetaData);
  const filterOperator = selectedFilter.get('operator');
  const useValueStringInsteadOfValuesArrayInFilter = FILTER_OPERATORS_USING_VALUE.includes(filterOperator || '');
  let updatedFilter;
  if (useValueStringInsteadOfValuesArrayInFilter) {
    const updatedFilterValue = filterValues.join(' OR ');
    updatedFilter = selectedFilter.set('value', updatedFilterValue);
  } else {
    updatedFilter = selectedFilter.set('values', ImmutableList(filterValues));
  }
  return updatedFilter;
};